/**
 * Lazy-loads React 17 production error codes (~38KB JSON) only when decoding
 * a minified invariant (typically on ErrorBoundary catch). Keeps the main bundle smaller.
 * Data matches react@17.0.2 — see facebook/react `scripts/error-codes/codes.json` at tag v17.0.2.
 */
type ErrorCodeMap = Record<string, string>;

let codesPromise: Promise<ErrorCodeMap> | null = null;

export function loadReact17ProductionErrorCodes(): Promise<ErrorCodeMap> {
  if (!codesPromise) {
    codesPromise = import("./react17ProductionErrorCodes.json").then((m) => m.default as ErrorCodeMap);
  }
  return codesPromise;
}

export async function getReactProductionErrorMessage(code: number): Promise<string | undefined> {
  const codes = await loadReact17ProductionErrorCodes();
  const text = codes[String(code)];
  return typeof text === "string" ? text : undefined;
}
